export default __webpack_public_path__ + "static/awards-88f401232aac7dc65bb2503f73ee8af9.jpg";